/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type MigrationStatusEnum = 'QUEUED' | 'IN_PROGRESS' | 'PENDING' | 'FAILED' | 'DONE';

export const MigrationStatusEnum = {

    QUEUED: 'QUEUED' as MigrationStatusEnum,

    IN_PROGRESS: 'IN_PROGRESS' as MigrationStatusEnum,

    PENDING: 'PENDING' as MigrationStatusEnum,

    FAILED: 'FAILED' as MigrationStatusEnum,

    DONE: 'DONE' as MigrationStatusEnum
};

